import { HierarchyContextProps } from "./interface";

export const hierarchyInitialState: HierarchyContextProps = {
  id: "",
  accessRights: [],
  changed: false,
  hierarchyNodes: [],
  parentTemplates: {
    domainReplacements: [],
    lists: [],
    rowGroups: [],
    singles: [],
    analysisSets: [],
    analysisMethods: [],
    dataSubsets: [],
    groupingFactors: [],
  },
  prefix: "",
  commentPanelStatus: {
    highlightCommentId: "",
    activeRelatedTo: "",
    showComments: false,
    commentFilter: "all",
  },
  doGetAccessRights: false,
  doTocSave: false,
  hierarchy: null,
  isSubscribed: false,
  saveRequestStatus: { requesting: false, error: false },
  saveTocRequestStatus: { requesting: false, error: false },
  savedHierarchy: null,
  tlfItemIndex: null,
  isNameChanged: false,
};
